import { render, staticRenderFns } from "./BonusPointList.vue?vue&type=template&id=1d33164c&scoped=true"
import script from "./BonusPointList.vue?vue&type=script&lang=js"
export * from "./BonusPointList.vue?vue&type=script&lang=js"
import style0 from "./BonusPointList.vue?vue&type=style&index=0&id=1d33164c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d33164c",
  null
  
)

export default component.exports